import React, { useState, useEffect, useCallback } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Stack, Container, Skeleton } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";

import Box from "@mui/material/Box";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Menu, MenuItem } from "@mui/material";
import { toast } from "react-toastify";
import LogoutConfirmModal from "../common/LogoutConfirm-Modal";
import { useUser } from "../../context/LoginDetail";
import { useTheme, useMediaQuery } from "@mui/material";
import { useModal } from "../../context/ModalContext";
import NotificationDropdown from "./NotificationDropdown";
import { useSettings } from "../../context/Settings";
import { assetUrl } from "../../utils/baseUrls";

// ── Static constant — hoisted outside component to prevent recreation ──
const navPaths = [
  "/",
  "/plot-marketplace",
  "/gioo-plots",
  "/syndicate-plots",
  "/rental-yield-plots",
  "/flats-villas",
  "/material-store",
  "/professional-services",
];

export default function Header() {
  const { settings } = useSettings();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { setShowLogin, setShowSignup, setShowReferral } = useModal();
  const navigate = useNavigate();
  const [logoutModalOpen, setLogoutModalOpen] = useState(false);

  const location = useLocation();
  // const [isLoggedIn, setIsLoggedIn] = useState(false);


  // const [user, setUser] = useState(null);
  // const toggleDrawer = (open) => () => {
  //   setDrawerOpen(open);
  // };

  const { user, loadUser, loading, notificationCount, setNotificationCount } = useUser();
  const isLoggedIn = !!user;

  const logoUrl = settings?.data?.logo
    ? assetUrl(settings.data.logo)
    : "/assets/images/logo.png";


  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));


  const paths = [
    "/",
    "/plot-marketplace",
    "/gioo-plots",
    "/syndicate-plots",
    "rental-yield-plots",
    "/flats-villas",
    "/material-store",
    "/professional-services",

  ];


  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  }, []);

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const formatText = useCallback((text) => {
    if (text === "/") return "Home";
    return text
      .replace("/", "")
      .split(/[- ]/)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  }, []);

  const isHeaderActive = useCallback((basePath) => {
    if (basePath === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(basePath);
  }, [location.pathname]);

  const handleLogoClick = useCallback((e) => {
    e.preventDefault();
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100);
    }
  }, [location.pathname, navigate]);

  const handleMenuToggle = useCallback(() => {
    setDrawerOpen((prev) => !prev);
  }, []);


  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  // Removed notification count fetching (moved to context)
  const [plotsAnchorEl, setPlotsAnchorEl] = React.useState(null);
  const plotsOpen = Boolean(plotsAnchorEl);

  const handlePlotsOpen = useCallback((e) => setPlotsAnchorEl(e.currentTarget), []);
  const handlePlotsClose = useCallback(() => setPlotsAnchorEl(null), []);

  return (
    <Box >


      {/* <Container>
                <AppBar position="static" color="primary">
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Typography variant="h6" component="a" href="/" sx={{ color: "white", textDecoration: "none" }}>
                        MyBrand
                    </Typography>
                    
                    <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
                        {navLinks.map((link) => (
                            <Button key={link.title} href={link.href} color="inherit">
                                {link.title}
                            </Button>
                        ))}
                        <Button href="/#" variant="contained" sx={{ borderRadius: "9999px", ml: 2 }}>
                            Sign Up
                        </Button>
                        <Button href="/#" color="inherit">
                            Login
                        </Button>
                    </Box>

                    
                    <IconButton
                        edge="end"
                        color="inherit"
                        aria-label="menu"
                        sx={{ display: { md: "none" } }}
                        onClick={toggleDrawer(true)}
                    >
                        <MenuIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            </Container> */}

      {/* <Container> */}

      {/* <AppBar
        position="fixed"
        elevation={1}
        color="default"
        sx={{
          top: 0,
          left: 0,
          right: 0,
          width: "100%",  // ensures full width of viewport
          overflowX: "hidden",
          bgcolor: "#FBF8F1",
          zIndex: (theme) => theme.zIndex.appBar,  // default 1100
          // ensures modal is above header
          minHeight: { xs: 64, md: 96 },   //stable height

        }}
      > */}
      <AppBar
        position="fixed"
        elevation={1}
        color="default"
        sx={{
          bgcolor: "#FBF8F1",
          zIndex: (theme) => theme.zIndex.appBar,
        }}
      >


        <Container maxWidth="xl">

          <Toolbar
            disableGutters
            sx={{
              minHeight: { xs: 64, md: 96 },
              display: "flex",
              alignItems: "center",
            }}
          >



            <RouterLink to="/">
              <Box
                component="img"
                src={logoUrl}
                alt="Geo Rental Farms Logo"
                fetchPriority="high"
                width={160}
                height={120}
                sx={{ height: { xs: 90, md: 120 }, width: "auto" }}
                onClick={handleLogoClick}
              />
            </RouterLink>



            {/* <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                flexGrow:1,
                justifyContent: "center",
                display: { xs: "none", md: "none", lg: "flex" },
              }}
            >
              {paths.map((path, i) => (
                <Button
                  key={i}
                  component={RouterLink}
                  to={path}
                  
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    color:
                      location.pathname === path
                        ? "secondary.main"
                        : "text.primary",
                  }}
                >
                  {formatText(path)}
                </Button>
              ))}
            </Stack> */}
            <Box sx={{ flexGrow: 1, display: "flex", justifyContent: "center" }}>
              <Stack
                direction="row"
                spacing={3}
                sx={{ display: { xs: "none", md: "flex" } }}
              >
                {/* {navLinks.map((link) => (
      <Button
        key={link.href}
        component={RouterLink}
        to={link.href}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          whiteSpace: "nowrap",
          color: isHeaderActive(link.basePath)
            ? "secondary.main"
            : "text.primary",
        }}
      >
        {link.title}
      </Button>
    ))} */}
                {navLinks.map((link) => {
                  const isPlotChild =
                    link.href === "/gioo-plots" ||
                    link.href === "/syndicate-plots" ||
                    // link.href === "/plot-marketplace" || 
                    link.href === "/rental-yield-plots";

                  // 🔹 Hide individual plot links ONLY between 1200–1400
                  if (isPlotChild) {
                    return (
                      <Box
                        key={link.href}
                        sx={{
                          "@media (min-width:900px) and (max-width:1400px)": {
                            display: "none",
                          },
                        }}
                      >
                        <Button
                          component={RouterLink}
                          to={link.href}
                          sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                            color: isHeaderActive(link.basePath)
                              ? "secondary.main"
                              : "text.primary",
                          }}
                        >
                          {link.title}
                        </Button>
                      </Box>
                    );
                  }

                  // 🔹 Replace "Plot MarketPlace" with dropdown (1200–1400)
                  if (link.href === "/plot-marketplace") {
                    return (
                      <React.Fragment key="plots-dropdown">
                        {/* Dropdown version */}
                        <Box
                          sx={{
                            display: "none",
                            "@media (min-width:900px) and (max-width:1400px)": {
                              display: "block",
                            },
                          }}
                        >
                          <Button
                            onClick={handlePlotsOpen}
                            endIcon={
                              <img
                                src="/assets/icons/dropdown.png"
                                alt="dropdown"
                                style={{
                                  width: 14,
                                  height: 14,
                                  transition: "0.3s",
                                  transform: plotsOpen ? "rotate(180deg)" : "rotate(0deg)",
                                }}
                              />
                            }
                            sx={{
                              textTransform: "none",
                              fontWeight: 600,
                              color:
                                isHeaderActive("/gioo-plots") ||
                                  isHeaderActive("/syndicate-plots") ||
                                  isHeaderActive("/plot-marketplace") ||
                                  isHeaderActive("/rental-yield-plots")
                                  ? "secondary.main"
                                  : "text.primary",
                            }}
                          >
                            Land
                          </Button>

                          <Menu
                            anchorEl={plotsAnchorEl}
                            open={plotsOpen}
                            onClose={handlePlotsClose}
                            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                            transformOrigin={{ vertical: "top", horizontal: "center" }}
                          >
                            <MenuItem onClick={() => { navigate("/plot-marketplace"); handlePlotsClose(); }}>
                              Land
                            </MenuItem>
                            <MenuItem onClick={() => { navigate("/gioo-plots"); handlePlotsClose(); }}>
                              Gioo Nano Plots
                            </MenuItem>
                            <MenuItem onClick={() => { navigate("/syndicate-plots"); handlePlotsClose(); }}>
                              Gio Rental Yield – Syndicate Plot
                            </MenuItem>
                            <MenuItem onClick={() => { navigate("/rental-yield-plots"); handlePlotsClose(); }}>
                              Gio Rental Yield
                            </MenuItem>
                          </Menu>
                        </Box>


                        {/* Normal link outside 1200–1400 */}
                        <Box
                          sx={{
                            "@media (min-width:900px) and (max-width:1400px)": {
                              display: "none",
                            },
                          }}
                        >
                          <Button
                            component={RouterLink}
                            to={link.href}
                            sx={{
                              textTransform: "none",
                              fontWeight: 600,
                              whiteSpace: "nowrap",
                              color: isHeaderActive(link.basePath)
                                ? "secondary.main"
                                : "text.primary",
                            }}
                          >
                            {link.title}
                          </Button>
                        </Box>
                      </React.Fragment>
                    );
                  }

                  // 🔹 Normal links
                  return (
                    <Button
                      key={link.href}
                      component={RouterLink}
                      to={link.href}
                      sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        color: isHeaderActive(link.basePath)
                          ? "secondary.main"
                          : "text.primary",
                      }}
                    >
                      {link.title}
                    </Button>
                  );
                })}

              </Stack>
            </Box>

            {/* <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{ display: { xs: "none", lg: "flex" } }}
            >
              {navLinks.map((link) => (
                <Button
                  key={link.href}
                  component={RouterLink}
                  to={link.href}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    flexWrap: "nowrap",      // prevent buttons from wrapping
    overflowX: "auto", 
                    color: isHeaderActive(link.basePath)
                      ? "secondary.main"
                      : "text.primary",
                  }}
                >
                  {link.title}
                </Button>
              ))}
            </Stack> */}


            <LogoutConfirmModal
              open={logoutModalOpen}
              onClose={() => setLogoutModalOpen(false)}
              onConfirm={() => {
                localStorage.removeItem("authToken");
                localStorage.removeItem("user");
                localStorage.removeItem("phone")
                navigate('/')
                toast.success("Logout Successful");
                loadUser(null);
                // setIsLoggedIn(false);

                setLogoutModalOpen(false);
              }}
            />



            {/* <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                display: { lg: "flex", xs: "none" },
              }}
            >

              {!isLoggedIn ? (
                <Box onClick={() => setOpenLogin(true)} sx={{ cursor: "pointer", display: "flex", gap: 1, alignContent: "center" }}>

                  <Button
                    variant="contained"

                    sx={{
                      backgroundColor: "#FFC107",
                      mr: 2,
                      display: { xs: "none", sm: "none", md: "none", lg: "block", xl: "flex" },
                      alignItems: "center",
                      gap: 1,
                      "& .text": {
                        display: { xs: "none", sm: "none", md: "none", lg: "none", xl: "block" },
                      },
                      "& .img": {
                        display: { xs: "none", sm: "none", md: "block", lg: "block", },
                      }
                    }}
                  >
                    <img
                      src="/assets/icons/handshake.png"
                      alt="handshake"
                      className="img"
                      style={{ width: 28, height: 24 }}
                    />

                    <span className="text">Agent/B2B Vendor</span>
                  </Button>

                  <Button variant="contained" sx={{

                    mr: 2,
                    display: { xs: "none", sm: "none", md: "none", lg: "block", xl: "flex" },
                    alignItems: "center",
                    justifyContent: 'center',
                    gap: 1,
                    "& .text": {
                      display: { xs: "none", sm: "none", md: "block", lg: "none", xl: "block" },
                    },
                    "& .img": {
                      display: { xs: "none", sm: "none", md: "none", lg: "block", },
                    }
                  }}>
                    <Box>

                      <img
                        src="/assets/icons/signup.png"
                        alt="login"
                        className="img"
                        style={{ width: 24, height: 22 }}
                      />
                    </Box>
                    <span className="text">SignUp</span>


                  </Button>

                </Box>
              ) : (
                <Box sx={{ display: "flex", gap: 1, alignContent: "center" }}>
                  <Box
                    sx={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      background: "linear-gradient(to right, #C7DD94, #92AF5D)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src="/assets/icons/notifications.png"
                      alt="notification"
                      style={{ width: "60%", height: "60%" }}
                    />
                  </Box>

                  <Box
                    onClick={handleMenuOpen}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      gap: 1,
                    }}
                  >

                    <Box
                      sx={{
                        width: 30,
                        height: 30,
                        borderRadius: "50%",
                        backgroundColor: "white",
                        overflow: "hidden",
                        display: "flex",
                      }}
                    >
                      <img
                        src={user?.avatar || "/assets/images/profile.png"}
                        alt="profile"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </Box>


                    <Typography
                      sx={{
                        maxWidth: 120,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {user?.name || "Profile"}
                    </Typography>


                    <img
                      src="/assets/icons/dropdown.png"
                      alt="dropdown"
                      style={{
                        width: 16,
                        height: 16,
                        transition: "0.3s",
                        transform: anchorEl ? "rotate(180deg)" : "rotate(0deg)",
                      }}
                    />
                  </Box>


                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    MenuListProps={{
                      sx: { minWidth: 150 }
                    }}
                  >
                    <MenuItem onClick={() => {
                      handleMenuClose();
                      navigate("/dashboard")

                    }}>My Dashboard</MenuItem>

                    <MenuItem
                      onClick={() => {
                        handleMenuClose();
                        setLogoutModalOpen(true);
                      }}
                    >
                      Logout
                    </MenuItem>
                  </Menu>
                </Box>


              )}
            </Stack> */}
            <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              sx={{
                display: { xs: "none", lg: "flex" },
                flexShrink: 0,
                ml: "auto",
              }}
            >

              {/* <Stack
              direction="row"
              spacing={1.5}
              alignItems="center"
              sx={{
                display: { xs: "none", lg: "flex" },
                flexWrap: "nowrap",
                flexShrink: 0,

              }}
            > */}
              {loading ? (
                <Stack direction="row" spacing={1.5} alignItems="center">
                  {/* Notification skeleton */}
                  <Skeleton variant="circular" width={30} height={30} />

                  {/* Avatar skeleton */}
                  <Skeleton variant="circular" width={30} height={30} />

                  {/* Name skeleton */}
                  <Skeleton variant="text" width={80} height={20} />
                </Stack>) :

                !isLoggedIn ? (
                  <Stack direction="row" spacing={1} alignItems="center" flexWrap="nowrap">
                    {/* <Button
                      variant="contained"
                      onClick={() => setShowLogin(true)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        backgroundColor: "#FFC107",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <img
                        src="/assets/icons/handshake.png"
                        alt="handshake"
                        style={{ width: 28, height: 24 }}
                      />
                      <Box
                        component="span"
                        sx={{
                          display: {
                            xs: "none",
                            sm: "none",
                            md: "none",
                            lg: "none",
                            xl: "block"
                          },
                        }}
                      >
                        Agent/B2B Vendor
                      </Box>
                    </Button> */}

                    <Button
                      variant="contained"
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        whiteSpace: "nowrap",
                      }}
                      onClick={() => setShowLogin(true)}
                    >
                      <img
                        src="/assets/icons/signup.png"
                        alt="signup"
                        style={{ width: 24, height: 22 }}
                      />

                      <Box
                        component="span"
                        sx={{
                          display: {
                            xs: "none",
                            sm: "none",
                            md: "none",
                            lg: "none",
                            xl: "block"
                          },
                        }}
                      >
                        SignUp
                      </Box>

                    </Button>
                  </Stack>
                ) : (
                  <Stack
                    direction="row"
                    spacing={1}
                    gap={2}
                    alignItems="center"
                    flexWrap="nowrap"
                    sx={{
                      flexShrink: 0,
                    }}
                  >
                    {/* Notifications */}
                    <NotificationDropdown
                      count={notificationCount}
                      onCountUpdate={setNotificationCount}
                    />

                    {/* Profile */}
                    <Box
                      onClick={handleMenuOpen}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        gap: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 30,
                          height: 30,
                          borderRadius: "50%",
                          overflow: "hidden",
                          display: "flex",
                        }}
                      >
                        <img
                          src={user?.avatar || "/assets/images/profile.png"}
                          alt="profile"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      </Box>

                      <Typography
                        sx={{
                          maxWidth: 120,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          display: {
                            xs: "none",
                            md: "block",
                          },
                          "@media (min-width: 1440px)": {
                            display: "none",
                          },
                        }}
                      >
                        {user?.name || "Profile"}
                      </Typography>

                      <img
                        src="/assets/icons/dropdown.png"
                        alt="dropdown"
                        style={{
                          width: 16,
                          height: 16,
                          transition: "0.3s",
                          transform: anchorEl ? "rotate(180deg)" : "rotate(0deg)",
                        }}
                      />
                    </Box>

                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={handleMenuClose}
                      disableScrollLock
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                      MenuListProps={{ sx: { minWidth: 150 } }}
                    >
                      <MenuItem
                        onClick={() => {
                          handleMenuClose();
                          navigate("/dashboard");
                        }}
                      >
                        My Dashboard
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          handleMenuClose();
                          setLogoutModalOpen(true);
                        }}
                      >
                        Logout
                      </MenuItem>
                    </Menu>
                  </Stack>
                )}
            </Stack>



            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                display: { xs: "flex", lg: "none" },
              }}
            >





              {loading ? (
                <Stack direction="row" spacing={1} alignItems="center">
                  <Skeleton variant="circular" width={32} height={32} />
                  <Skeleton variant="circular" width={32} height={32} />


                </Stack>

              ) :
                !isLoggedIn ? (
                  // <IconButton onClick={() => setOpenLogin(true)}>
                  //   <img
                  //     src="/assets/icons/profile.png"
                  //     alt="login"
                  //     style={{ width: 26 }}
                  //   />
                  // </IconButton>
                  <Box onClick={() => setShowLogin(true)} sx={{ display: "flex", alignContent: "center" }}>
                    {/* <Button variant="contained" sx={{ backgroundColor: "#FFC107", mr: 2 }}>
                      <img src="/assets/icons/handshake.png" style={{ width: 24, height: 24 }} />
                    </Button> */}

                    <Button variant="contained" sx={{

                      mr: 2,
                      // display: { xs: "block", sm: "none", md: "none", lg: "block", xl: "block" },
                      alignItems: "center",
                      justifyContent: 'center',
                      gap: 1,
                      "& .text": {
                        display: { xs: "none", sm: "block", md: "none", lg: "none", xl: "block" },
                      },
                      "& .img": {
                        display: { xs: "block", sm: "none", md: "block", lg: "block", xl: "none" },
                      }
                    }}>
                      <span className="text">Login/SignUp</span>
                      <img
                        src="/assets/icons/signup.png"
                        alt="login"
                        className="img"
                        style={{ width: 24, height: 24 }}
                      />
                    </Button>
                  </Box>

                ) : (

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <NotificationDropdown
                      count={notificationCount}
                      onCountUpdate={setNotificationCount}
                    />
                    <IconButton onClick={handleMenuOpen}>
                      <img
                        src={encodeURI(user?.avatar) || "/assets/images/profilee.png"}
                        alt="profile"
                        style={{ width: 32, height: 32, borderRadius: "50%" }}
                      />
                    </IconButton>
                  </Box>
                )}

              {/* Mobile Menu Icon */}
              <IconButton onClick={handleMenuToggle} sx={{ display: { xs: "flex", md: "none" } }}>
                <MenuIcon />
              </IconButton>
            </Stack>


          </Toolbar>
        </Container>

      </AppBar>
      {/* </Container> */}

      {/* <Toolbar/>
      <Toolbar/> */}



      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: { zIndex: 1300 }   // above AppBar (1100)
        }}
      >
        <Box sx={{ width: 250 }}>
          {/* <List>
            {navLinks.map((link) => (
              <ListItem
                button
                key={link.title}
                onClick={() => {
                  navigate(link.href);
                  toggleDrawer(false)(); // close drawer manually
                }}
              >
                <ListItemText primary={link.title} />
              </ListItem>
            ))}
          </List> */}
          <List>
            {navLinks.map((link) => (
              <ListItem
                button
                key={link.title}
                onClick={() => {
                  navigate(link.href);
                  setDrawerOpen(false);
                }}
                sx={{
                  color: isHeaderActive(link.basePath)
                    ? "secondary.main"
                    : "text.primary",
                  fontWeight: isHeaderActive(link.basePath) ? 600 : 400,
                }}
              >
                <ListItemText primary={link.title} />
              </ListItem>
            ))}
          </List>



          {/* <ListItem
            button
            onClick={() => {
              navigate("/notifications");
              toggleDrawer(false)();
            }}
          >
            <Box
              sx={{
                width: 40,
                height: 35,
                borderRadius: "50%",
                background: "linear-gradient(to right, #C7DD94, #92AF5D)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                mr: 2
              }}
            >
              <img
                src="/assets/icons/notifications.png"
                alt="notification"
                style={{
                  width: "60%",
                  height: "60%",
                  objectFit: "contain"
                }}
              />
            </Box>
            <ListItemText primary="Notifications" />
          </ListItem> */}
        </Box>
      </Drawer>


    </Box>
  );
}

export const navLinks = [
  { title: "Land", href: "/plot-marketplace", basePath: "/plot-marketplace" },
  { title: "Gioo Nano Plots", href: "/gioo-plots", basePath: "/gioo-plots" },
  { title: "Gio Rental Yield – Syndicate Plot", href: "/syndicate-plots", basePath: "/syndicate-plots" },
  { title: "Gio Rental Yield", href: "/rental-yield-plots", basePath: "/rental-yield-plots" },
  { title: "Flats / Villas", href: "/flats-villas", basePath: "/flats-villas" },
  { title: "Material Store", href: "/material-store", basePath: "/material-store" },
  { title: "Professional Services", href: "/professional-services", basePath: "/professional-services" },
];